import { useState, useEffect } from 'react'
import { getSettingCertificateCategoryAPI } from '../services/setting/certificate'

function UseCertificateCategory() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getSettingCertificateCategoryAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return { value: d.paymentCerCateId, label: d.paymentCertCategory }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])

  return data
}

export default UseCertificateCategory
